import React, { useEffect, useMemo, useRef } from "react";
import { CSVLink } from "react-csv";

import { ActiveLearningInquiryEvaluationsCSV } from "../../../../state";

import styles from "./CsvDownloadButton.module.scss";

type Props = {
  calling: boolean;
  isSuccessCSVDownload: boolean;
  csvData: ActiveLearningInquiryEvaluationsCSV | null;
  onDownload: () => void;
};

const toCsvCell = (value: string | number | null | undefined) =>
  String(value ?? "");

const buildCsvRows = (csvData: ActiveLearningInquiryEvaluationsCSV | null) => {
  if (!csvData) return [];

  const rows: string[][] = [
    ["学校名", toCsvCell(csvData.school.name)],
    ["クラス名", toCsvCell(csvData.klass.name)],
    [],
    [
      "生徒名",
      "問い",
      "合計スコア",
      "内発性",
      "思考の深さ",
      "具体性",
      "内発性（指導例）",
      "思考の深さ（指導例）",
      "具体性（指導例）",
    ],
  ];

  csvData.active_learning_inquiry_evaluations.forEach(studentEvaluation => {
    const evaluation = studentEvaluation.data;
    rows.push([
      toCsvCell(studentEvaluation.student.full_name),
      toCsvCell(evaluation?.active_learning_inquiry),
      toCsvCell(evaluation?.total_score),
      toCsvCell(evaluation?.intrinsic_motivation_score),
      toCsvCell(evaluation?.thinking_depth_score),
      toCsvCell(evaluation?.concreteness_score),
      toCsvCell(evaluation?.instructional_example_for_intrinsic_motivation),
      toCsvCell(evaluation?.instructional_example_for_thinking_depth),
      toCsvCell(evaluation?.instructional_example_for_concreteness),
    ]);
  });

  return rows;
};

const buildFilename = (csvData: ActiveLearningInquiryEvaluationsCSV) => {
  const now = new Date();
  const date = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
    2,
    "0",
  )}${String(now.getDate()).padStart(2, "0")}`;
  return `${date}_実践編_${csvData.school.name}_${csvData.klass.name}.csv`;
};

const CsvDownloadButton: React.FC<Props> = ({
  calling,
  isSuccessCSVDownload,
  csvData,
  onDownload,
}) => {
  const csvLinkRef = useRef<
    CSVLink & HTMLAnchorElement & { link?: HTMLAnchorElement }
  >(null);
  const csvRows = useMemo(() => buildCsvRows(csvData), [csvData]);

  useEffect(() => {
    if (isSuccessCSVDownload) {
      csvLinkRef.current?.link?.click();
    }
  }, [isSuccessCSVDownload]);

  return (
    <>
      <button
        className={styles.csvButton}
        disabled={calling}
        onClick={onDownload}
        type="button"
      >
        {calling ? "ダウンロード中..." : "CSVダウンロード"}
      </button>
      {csvData && (
        <CSVLink
          ref={csvLinkRef}
          filename={buildFilename(csvData)}
          data={csvRows}
          uFEFF
          hidden
        />
      )}
    </>
  );
};

export default CsvDownloadButton;
